import { combineReducers } from 'redux';
import { reducer as formReducer, actionTypes as formActionTypes } from 'redux-form';
import paginate from './common/reducers/paginate';
import junction from './common/reducers/junction';
import filter from './common/reducers/filter';
import auth from './auth/reducer';
import profile from './dashboard/profile/reducer';
import analytics from './dashboard/home/reducer';
import formsAnalytics from './dashboard/individualConsultationFormsAnalytics/reducer';
import update from 'immutability-helper';
import utils from './common/services/utils';
import * as AuthActionTypes from './auth/actions';
import * as FranchiseeActionTypes from './dashboard/franchisees/actions';
import * as TerritoryActionTypes from './dashboard/territories/actions';
import * as TeacherActionTypes from './dashboard/teachers/actions';
import * as TermActionTypes from './dashboard/terms/actions';
import * as RoleActionTypes from './dashboard/roles/actions';
import * as UserActionTypes from './dashboard/users/actions';
import * as GradeActionTypes from './dashboard/grades/actions';
import * as CenterActionTypes from './dashboard/centers/actions';
import * as PriceActionTypes from './dashboard/prices/actions';
import * as DiscountActionTypes from './dashboard/discounts/actions';
import * as TermHolidayPeriodsActionTypes from './dashboard/termHolidayPeriods/actions';
import * as DocumentFormsActionTypes from './dashboard/documentForms/actions';
import * as ParentActionTypes from './dashboard/parents/actions';
import * as ChildActionTypes from './dashboard/children/actions';
import * as ParentDocumentActionTypes from './dashboard/parentDocuments/actions';
import * as TrialLessonActionTypes from './dashboard/trialLessons/actions';
import * as WaitingListActionTypes from './dashboard/waitingList/actions';
import * as VoucherActionTypes from './dashboard/vouchers/actions';
import * as PaymentHistoryActionTypes from './dashboard/paymentHistory/actions';
import * as InstalmentPaymentsActionTypes from './dashboard/instalmentPayments/actions';
import * as EnrolmentActionTypes from './dashboard/enrolments/actions';
import * as HowYouLearnActionTypes from './dashboard/howYouLearn/actions';
import * as AppActionTypes from './dashboard/apps/actions';
import * as ParentsNotChooseCenterActionTypes from './dashboard/reports/parentsNotChooseCenter/actions';
import * as MessageTemplateActionTypes from './dashboard/messageTemplates/actions';
import * as CenterHolidayActionTypes from './dashboard/centerHolidays/actions';
import * as WeeklyInformationActionTypes from './dashboard/weeklyInformations/actions';
import * as IndividualConsultationActionTypes from './dashboard/individualConsultations/actions';
import * as IndividualConsultationDocumentActionTypes from './dashboard/individualConsultationDocuments/actions';
import * as ReportChildrenActionTypes from './dashboard/reports/reportChildren/actions';
import * as KindergartenMonthlyReportActionTypes from './dashboard/reports/kindergartenMonthly/actions';
import * as MonthlyPaymentReportActionTypes from './dashboard/reports/monthlyPayment/actions';
import * as MoveLessonActionTypes from './dashboard/moveLessons/actions';
import * as SessionManagementActionTypes from './dashboard/reports/sessionManagement/actions';
import * as IndividualConsultationScheduleActionTypes from './dashboard/individualConsultationsSchedule/actions';
import * as LessonAttendanceActionTypes from './dashboard/attendance/actions';
import * as KindergartenAttendanceActionTypes from './dashboard/kindergartenAttendance/actions';
import * as PrepaidTermsReportActionTypes from './dashboard/reports/prepaidTerms/actions';
import * as CancellationCreditNotesReportActionTypes from './dashboard/reports/cancellationCreditNotes/actions';
import * as LoyalChildrenReportActionTypes from './dashboard/reports/loyalChildren/actions';
import * as RoyaltyReportActionTypes from './dashboard/reports/royaltyReport/actions';
import * as CentralisedRoyaltyReportActionTypes from './dashboard/reports/centralisedRoyalty/actions';
import * as SoftwareFeeReportActionTypes from './dashboard/reports/softwareFee/actions';
import * as MasterFranchiseesActionTypes from './dashboard/headOffice/masterFranchisees/actions';
import * as DiscountUsageActionTypes from './dashboard/discounts/actions';
import * as UpcomingCancellationsActionTypes from './dashboard/reports/upcomingCancellations/actions';
import * as EmailBouncesActionTypes from './dashboard/emailBounces/actions';
import * as CampaignStatsActionTypes from './dashboard/reports/campaignStats/actions';
import * as IndividualConsultationFormResponseTypes from './dashboard/individualConsultationForms/actions';
import * as selfAssessmentTypes from './dashboard/selfAssessments/actions';
import * as NoteActionTypes from './dashboard/notes/actions';
import * as WorkshopActionTypes from './dashboard/workshops/actions';
import * as WorkshopPaymentsActionTypes from './dashboard/workshopPayments/actions';
import * as MakeupSummaryActionTypes from './dashboard/parentMakeupSummary/actions';
import * as SentEmailsActionTypes from './dashboard/reports/sentEmails/actions';
import * as InstalmentPlanTemplateActionTypes from './dashboard/instalmentPlans/actions';
import * as PaymentActionTypes from './dashboard/instalmentPayments/actions';
import * as SavedQueryActionTypes from './dashboard/home/savedQueries/actions';

import language from './languages/reducer';
import { lookups, franchisor } from './init/reducers';
import releaseNotes from './dashboard/default/releaseNotes/reducer';
import exportToFile from './common/reducers/exportToFile';

const initialState = {
	franchisees: {}, territories: {}, centers: {}, terms: {}, roles: {}, grades: {}, termHolidayPeriods: {}, prices: {}, discounts: {}, parents: {}, children: {}, parentDocuments: {},
	documentForms: {}, weeklyPrograms: {}, franchiseeAllTerritories: {}, users: {}, permissions: {}, trialLessons: {}, paymentMethodsByOwner: {}, paymentConfigurations: {}, vouchers: {},
	paymentHistories: {}, instalmentPayments: {}, howYouLearn: {}, userMappings: {}, apps: {}, messageTemplates: {}, weeklyInformations: {}, localizations: {}, individualConsultations: {},
	childLessons: {}, lessonDates: {}, centerHolidays: {}, parentsWithPendingPayment: {}, franchisorSettings: {},
	kindergartenAttendances: {}, kindergartenPaymentDetails: {}, kindergartenPayments: {},
	parentsNotChooseCenter: {}, reportChildrenDetails: {}, reportChildrenSummary: {}, schoolYears: {}, sessionManagement: {},
	kindergartenMonthlyReport: {}, kindergartenPaymentYears: {}, monthlyPaymentReport: {}, paymentYears: {},
	individualConsultationScheduleItems: {}, individualConsultationDocuments: {},
	teachers: {}, noTeacherUsers: {}, waitingLists: {}, prepaidTermsReport: {}, enrolments: {}, loyalChildrenReport: {}, royaltyReport: {}, centralisedRoyaltyReport: {},
	cancellationCreditNotesReport: {}, softwareFeeReport: {}, masterFranchisees: {}, discountUsage: {}, upcomingCancellations: {}, emailBounces: {}, campaignStats: {}, campaignStatsDetails: {},
	individualConsultationFormResponses: {}, selfAssessments: {}, medicalInformations: {}, notes: {}, workshops: {}, weekSessions: {}, childWorkshopSessions: {}, workshopPayments: {},
	makeupSummary: {}, adHocMessageTemplates: {}, authenticationRecords: {}, workshopSessions: {}, sentEmails: {}, instalmentPlanTemplates: {},
	payments: {}, savedQueries: {}
};
const entities = (state = initialState, action) => {

	let newState = state;

	if (action.type === AuthActionTypes.LOGOUT) {
		return initialState;
	}

	if (action.response && action.response.entities) {

		Object.keys(action.response.entities).forEach(key => {
			const replace = action.replace;
			if (replace && replace.replace && (!replace.entityForReplace || replace.entityForReplace === key)) {
				if (replace.entityForReplace && replace.keyForReplace) {
					let entity = state[key];
					entity = utils.filter(entity, (x) => x[replace.keyForReplace] !== replace.valueForReplace);

					newState = update(newState, {
						[key]: { $set: entity }
					});
				}
				else {
					newState = update(newState, {
						[key]: { $set: {} }
					});
				}
			}
			if (action.remove) {
				let keys = action.response.entities[key];
				newState = update(newState, {
					[key]: { $unset: Object.keys(keys) }
				});
			}
			else {
				newState = update(newState, {
					[key]: { $merge: action.response.entities[key] }
				});
			}
		});
		return newState;
	}
	return state;
};

// Updates the pagination data for different actions.
const pagination = combineReducers({
	masterFranchisees: paginate({
		mapActionToKey: action => 'all',
		types: [
			MasterFranchiseesActionTypes.MASTER_FRANCHISEES_REQUEST,
			MasterFranchiseesActionTypes.MASTER_FRANCHISEES_SUCCESS,
			MasterFranchiseesActionTypes.MASTER_FRANCHISEES_FAILURE
		]
	}),
	franchisees: paginate({
		mapActionToKey: action => 'all',
		types: [
			FranchiseeActionTypes.FRANCHISEES_REQUEST,
			FranchiseeActionTypes.FRANCHISEES_SUCCESS,
			FranchiseeActionTypes.FRANCHISEES_FAILURE
		]
	}),
	territoriesByFranchisee: paginate({
		mapActionToKey: action => action.franchiseeId.toString(),
		types: [
			TerritoryActionTypes.TERRITORIES_REQUEST,
			TerritoryActionTypes.TERRITORIES_SUCCESS,
			TerritoryActionTypes.TERRITORIES_FAILURE
		]
	}),
	teachersByFranchisee: paginate({
		mapActionToKey: action => action.franchiseeId.toString(),
		types: [
			TeacherActionTypes.TEACHERS_REQUEST,
			TeacherActionTypes.TEACHERS_SUCCESS,
			TeacherActionTypes.TEACHERS_FAILURE
		]
	}),
	centersByFranchisee: paginate({
		mapActionToKey: action => action.franchiseeId.toString(),
		types: [
			CenterActionTypes.CENTERS_BY_FRANCHISEE_REQUEST,
			CenterActionTypes.CENTERS_BY_FRANCHISEE_SUCCESS,
			CenterActionTypes.CENTERS_BY_FRANCHISEE_FAILURE
		]
	}),
	terms: paginate({
		mapActionToKey: action => 'all',
		types: [
			TermActionTypes.TERMS_REQUEST,
			TermActionTypes.TERMS_SUCCESS,
			TermActionTypes.TERMS_FAILURE
		]
	}),
	roles: paginate({
		mapActionToKey: action => 'all',
		types: [
			RoleActionTypes.ROLES_REQUEST,
			RoleActionTypes.ROLES_SUCCESS,
			RoleActionTypes.ROLES_FAILURE
		]
	}),
	users: paginate({
		mapActionToKey: action => 'all',
		types: [
			UserActionTypes.USERS_REQUEST,
			UserActionTypes.USERS_SUCCESS,
			UserActionTypes.USERS_FAILURE
		]
	}),
	grades: paginate({
		mapActionToKey: action => 'all',
		types: [
			GradeActionTypes.GRADES_REQUEST,
			GradeActionTypes.GRADES_SUCCESS,
			GradeActionTypes.GRADES_FAILURE
		]
	}),
	termHolidayPeriods: paginate({
		mapActionToKey: action => action.termId ? action.termId.toString() : 'all',
		types: [
			TermHolidayPeriodsActionTypes.TERM_HOLIDAY_PERIODS_REQUEST,
			TermHolidayPeriodsActionTypes.TERM_HOLIDAY_PERIODS_SUCCESS,
			TermHolidayPeriodsActionTypes.TERM_HOLIDAY_PERIODS_FAILURE
		]
	}),
	prices: paginate({
		mapActionToKey: action => 'all',
		types: [
			PriceActionTypes.PRICES_REQUEST,
			PriceActionTypes.PRICES_SUCCESS,
			PriceActionTypes.PRICES_FAILURE
		]
	}),
	discounts: paginate({
		mapActionToKey: action => 'all',
		types: [
			DiscountActionTypes.DISCOUNTS_REQUEST,
			DiscountActionTypes.DISCOUNTS_SUCCESS,
			DiscountActionTypes.DISCOUNTS_FAILURE
		]
	}),
	documentForms: paginate({
		mapActionToKey: action => 'all',
		types: [
			DocumentFormsActionTypes.DOCUMENT_FORMS_REQUEST,
			DocumentFormsActionTypes.DOCUMENT_FORMS_SUCCESS,
			DocumentFormsActionTypes.DOCUMENT_FORMS_FAILURE
		]
	}),
	parents: paginate({
		mapActionToKey: action => 'all',
		types: [
			ParentActionTypes.PARENTS_REQUEST,
			ParentActionTypes.PARENTS_SUCCESS,
			ParentActionTypes.PARENTS_FAILURE
		]
	}),
	childrenByParent: paginate({
		mapActionToKey: action => action.parentId.toString(),
		types: [
			ChildActionTypes.CHILDREN_REQUEST,
			ChildActionTypes.CHILDREN_SUCCESS,
			ChildActionTypes.CHILDREN_FAILURE
		]
	}),
	parentDocuments: paginate({
		mapActionToKey: action => action.parentId.toString(),
		types: [
			ParentDocumentActionTypes.PARENT_DOCUMENTS_REQUEST,
			ParentDocumentActionTypes.PARENT_DOCUMENTS_SUCCESS,
			ParentDocumentActionTypes.PARENT_DOCUMENTS_FAILURE
		]
	}),
	centers: paginate({
		mapActionToKey: action => 'all',
		types: [
			CenterActionTypes.CENTERS_REQUEST,
			CenterActionTypes.CENTERS_SUCCESS,
			CenterActionTypes.CENTERS_FAILURE
		]
	}),
	trialLessons: paginate({
		mapActionToKey: action => 'all',
		types: [
			TrialLessonActionTypes.TRIAL_LESSONS_REQUEST,
			TrialLessonActionTypes.TRIAL_LESSONS_SUCCESS,
			TrialLessonActionTypes.TRIAL_LESSONS_FAILURE
		]
	}),
	waitingLists: paginate({
		mapActionToKey: action => 'all',
		types: [
			WaitingListActionTypes.WAITING_LIST_REQUEST,
			WaitingListActionTypes.WAITING_LIST_SUCCESS,
			WaitingListActionTypes.WAITING_LIST_FAILURE
		]
	}),
	vouchers: paginate({
		mapActionToKey: action => 'all',
		types: [
			VoucherActionTypes.VOUCHERS_REQUEST,
			VoucherActionTypes.VOUCHERS_SUCCESS,
			VoucherActionTypes.VOUCHERS_FAILURE
		]
	}),
	paymentHistories: paginate({
		mapActionToKey: action => action.parentId ? action.parentId.toString() : 'all',
		types: [
			PaymentHistoryActionTypes.PAYMENT_HISTORIES_REQUEST,
			PaymentHistoryActionTypes.PAYMENT_HISTORIES_SUCCESS,
			PaymentHistoryActionTypes.PAYMENT_HISTORIES_FAILURE
		]
	}),
	workshopPayments: paginate({
		mapActionToKey: action => action.parentId ? `parent-${action.parentId}` : 'all',
		types: [
			WorkshopPaymentsActionTypes.WORKSHOP_PAYMENTS_REQUEST,
			WorkshopPaymentsActionTypes.WORKSHOP_PAYMENTS_SUCCESS,
			WorkshopPaymentsActionTypes.WORKSHOP_PAYMENTS_FAILURE
		]
	}),
	instalmentPayments: paginate({
		mapActionToKey: action => 'all',
		types: [
			InstalmentPaymentsActionTypes.INSTALMENT_PAYMENTS_REQUEST,
			InstalmentPaymentsActionTypes.INSTALMENT_PAYMENTS_SUCCESS,
			InstalmentPaymentsActionTypes.INSTALMENT_PAYMENTS_FAILURE
		]
	}),
	enrolments: paginate({
		mapActionToKey: action => action.parentId ? action.parentId.toString() : 'all',
		types: [
			EnrolmentActionTypes.ENROLMENTS_REQUEST,
			EnrolmentActionTypes.ENROLMENTS_SUCCESS,
			EnrolmentActionTypes.ENROLMENTS_FAILURE
		]
	}),
	howYouLearn: paginate({
		mapActionToKey: action => 'all',
		types: [
			HowYouLearnActionTypes.HOW_YOU_LEARN_REQUEST,
			HowYouLearnActionTypes.HOW_YOU_LEARN_SUCCESS,
			HowYouLearnActionTypes.HOW_YOU_LEARN_FAILURE
		]
	}),
	apps: paginate({
		mapActionToKey: action => 'all',
		types: [
			AppActionTypes.APPS_REQUEST,
			AppActionTypes.APPS_SUCCESS,
			AppActionTypes.APPS_FAILURE
		]
	}),
	parentsNotChooseCenter: paginate({
		mapActionToKey: action => 'all',
		types: [
			ParentsNotChooseCenterActionTypes.PARENTS_NOT_CHOOSE_CENTER_REQUEST,
			ParentsNotChooseCenterActionTypes.PARENTS_NOT_CHOOSE_CENTER_SUCCESS,
			ParentsNotChooseCenterActionTypes.PARENTS_NOT_CHOOSE_CENTER_FAILURE
		]
	}),
	reportChildrenDetails: paginate({
		mapActionToKey: action => action.reportType,
		types: [
			ReportChildrenActionTypes.REPORT_CHILDREN_REQUEST,
			ReportChildrenActionTypes.REPORT_CHILDREN_SUCCESS,
			ReportChildrenActionTypes.REPORT_CHILDREN_FAILURE
		]
	}),
	messageTemplates: paginate({
		mapActionToKey: action => 'all',
		types: [
			MessageTemplateActionTypes.MESSAGE_TEMPLATES_REQUEST,
			MessageTemplateActionTypes.MESSAGE_TEMPLATES_SUCCESS,
			MessageTemplateActionTypes.MESSAGE_TEMPLATES_FAILURE
		]
	}),
	centerHolidays: paginate({
		mapActionToKey: action => action.centerId.toString(),
		types: [
			CenterHolidayActionTypes.CENTER_HOLIDAYS_REQUEST,
			CenterHolidayActionTypes.CENTER_HOLIDAYS_SUCCESS,
			CenterHolidayActionTypes.CENTER_HOLIDAYS_FAILURE
		]
	}),
	weeklyInformations: paginate({
		mapActionToKey: action => 'all',
		types: [
			WeeklyInformationActionTypes.WEEKLY_INFORMATIONS_REQUEST,
			WeeklyInformationActionTypes.WEEKLY_INFORMATIONS_SUCCESS,
			WeeklyInformationActionTypes.WEEKLY_INFORMATIONS_FAILURE
		]
	}),
	individualConsultations: paginate({
		mapActionToKey: action => action.parentId ? `parent-${action.parentId}` : 'all',
		types: [
			IndividualConsultationActionTypes.INDIVIDUAL_CONSULTATIONS_REQUEST,
			IndividualConsultationActionTypes.INDIVIDUAL_CONSULTATIONS_SUCCESS,
			IndividualConsultationActionTypes.INDIVIDUAL_CONSULTATIONS_FAILURE
		]
	}),
	individualConsultationDocuments: paginate({
		mapActionToKey: action => action.paymentId.toString(),
		types: [
			IndividualConsultationDocumentActionTypes.INDIVIDUAL_CONSULTATION_DOCUMENTS_REQUEST,
			IndividualConsultationDocumentActionTypes.INDIVIDUAL_CONSULTATION_DOCUMENTS_SUCCESS,
			IndividualConsultationDocumentActionTypes.INDIVIDUAL_CONSULTATION_DOCUMENTS_FAILURE
		]
	}),
	kindergartenMonthlyReport: paginate({
		mapActionToKey: action => 'all',
		types: [
			KindergartenMonthlyReportActionTypes.KINDERGARTEN_MONTHLY_REPORT_REQUEST,
			KindergartenMonthlyReportActionTypes.KINDERGARTEN_MONTHLY_REPORT_SUCCESS,
			KindergartenMonthlyReportActionTypes.KINDERGARTEN_MONTHLY_REPORT_FAILURE
		]
	}),
	monthlyPaymentReport: paginate({
		mapActionToKey: action => 'all',
		types: [
			MonthlyPaymentReportActionTypes.MONTHLY_PAYMENT_REPORT_REQUEST,
			MonthlyPaymentReportActionTypes.MONTHLY_PAYMENT_REPORT_SUCCESS,
			MonthlyPaymentReportActionTypes.MONTHLY_PAYMENT_REPORT_FAILURE
		]
	}),
	prepaidTermsReport: paginate({
		mapActionToKey: action => 'all',
		types: [
			PrepaidTermsReportActionTypes.PREPAID_TERMS_REPORT_REQUEST,
			PrepaidTermsReportActionTypes.PREPAID_TERMS_REPORT_SUCCESS,
			PrepaidTermsReportActionTypes.PREPAID_TERMS_REPORT_FAILURE
		]
	}),
	cancellationCreditNotesReport: paginate({
		mapActionToKey: action => 'all',
		types: [
			CancellationCreditNotesReportActionTypes.CANCELLATION_CREDIT_NOTES_REPORT_REQUEST,
			CancellationCreditNotesReportActionTypes.CANCELLATION_CREDIT_NOTES_REPORT_SUCCESS,
			CancellationCreditNotesReportActionTypes.CANCELLATION_CREDIT_NOTES_REPORT_FAILURE
		]
	}),
	royaltyReport: paginate({
		mapActionToKey: action => 'all',
		types: [
			RoyaltyReportActionTypes.ROYALTY_REPORT_REQUEST,
			RoyaltyReportActionTypes.ROYALTY_REPORT_SUCCESS,
			RoyaltyReportActionTypes.ROYALTY_REPORT_FAILURE
		]
	}),
	centralisedRoyaltyReport: paginate({
		mapActionToKey: action => 'all',
		types: [
			CentralisedRoyaltyReportActionTypes.CENTRALISED_ROYALTY_REPORT_REQUEST,
			CentralisedRoyaltyReportActionTypes.CENTRALISED_ROYALTY_REPORT_SUCCESS,
			CentralisedRoyaltyReportActionTypes.CENTRALISED_ROYALTY_REPORT_FAILURE
		]
	}),
	softwareFeeReport: paginate({
		mapActionToKey: action => 'all',
		types: [
			SoftwareFeeReportActionTypes.SOFTWARE_FEE_REPORT_REQUEST,
			SoftwareFeeReportActionTypes.SOFTWARE_FEE_REPORT_SUCCESS,
			SoftwareFeeReportActionTypes.SOFTWARE_FEE_REPORT_FAILURE
		]
	}),
	loyalChildrenReport: paginate({
		mapActionToKey: action => 'all',
		types: [
			LoyalChildrenReportActionTypes.LOYAL_CHILDREN_REPORT_REQUEST,
			LoyalChildrenReportActionTypes.LOYAL_CHILDREN_REPORT_SUCCESS,
			LoyalChildrenReportActionTypes.LOYAL_CHILDREN_REPORT_FAILURE
		]
	}),
	sessionManagement: paginate({
		mapActionToKey: action => 'all',
		types: [
			SessionManagementActionTypes.SESSION_MANAGEMENT_REPORT_REQUEST,
			SessionManagementActionTypes.SESSION_MANAGEMENT_REPORT_SUCCESS,
			SessionManagementActionTypes.SESSION_MANAGEMENT_REPORT_FAILURE
		]
	}),
	moveLessonsChildren: paginate({
		mapActionToKey: action => 'all',
		types: [
			MoveLessonActionTypes.MOVE_LESSONS_SEARCH_CHILDREN_REQUEST,
			MoveLessonActionTypes.MOVE_LESSONS_SEARCH_CHILDREN_SUCCESS,
			MoveLessonActionTypes.MOVE_LESSONS_SEARCH_CHILDREN_FAILURE
		]
	}),
	individualConsultationSchedule: paginate({
		mapActionToKey: action => 'all',
		types: [
			IndividualConsultationScheduleActionTypes.INDIVIDUAL_CONSULTATIONS_SCHEDULE_ITEMS_REQUEST,
			IndividualConsultationScheduleActionTypes.INDIVIDUAL_CONSULTATIONS_SCHEDULE_ITEMS_SUCCESS,
			IndividualConsultationScheduleActionTypes.INDIVIDUAL_CONSULTATIONS_SCHEDULE_ITEMS_FAILURE
		]
	}),
	discountUsage: paginate({
		mapActionToKey: action => 'all',
		types: [
			DiscountUsageActionTypes.DISCOUNT_USAGE_REQUEST,
			DiscountUsageActionTypes.DISCOUNT_USAGE_SUCCESS,
			DiscountUsageActionTypes.DISCOUNT_USAGE_FAILURE
		]
	}),
	upcomingCancellations: paginate({
		mapActionToKey: action => 'all',
		types: [
			UpcomingCancellationsActionTypes.UPCOMING_CANCELLATIONS_REQUEST,
			UpcomingCancellationsActionTypes.UPCOMING_CANCELLATIONS_SUCCESS,
			UpcomingCancellationsActionTypes.UPCOMING_CANCELLATIONS_FAILURE
		]
	}),
	emailBounces: paginate({
		mapActionToKey: action => 'all',
		types: [
			EmailBouncesActionTypes.EMAIL_BOUNCES_REQUEST,
			EmailBouncesActionTypes.EMAIL_BOUNCES_SUCCESS,
			EmailBouncesActionTypes.EMAIL_BOUNCES_FAILURE
		]
	}),
	campaignStats: paginate({
		mapActionToKey: action => 'all',
		types: [
			CampaignStatsActionTypes.CAMPAIGN_STATS_REQUEST,
			CampaignStatsActionTypes.CAMPAIGN_STATS_SUCCESS,
			CampaignStatsActionTypes.CAMPAIGN_STATS_FAILURE
		]
	}),
	campaignStatsDetails: paginate({
		mapActionToKey: action => 'all',
		types: [
			CampaignStatsActionTypes.CAMPAIGN_STATS_DETAILS_REQUEST,
			CampaignStatsActionTypes.CAMPAIGN_STATS_DETAILS_SUCCESS,
			CampaignStatsActionTypes.CAMPAIGN_STATS_DETAILS_FAILURE
		]
	}),
	individualConsultationFormResponses: paginate({
		mapActionToKey: action => action.paymentId.toString(),
		types: [
			IndividualConsultationFormResponseTypes.INDIVIDUAL_CONSULTATION_FORM_RESPONSES_REQUEST,
			IndividualConsultationFormResponseTypes.INDIVIDUAL_CONSULTATION_FORM_RESPONSES_SUCCESS,
			IndividualConsultationFormResponseTypes.INDIVIDUAL_CONSULTATION_FORM_RESPONSES_FAILURE
		]
	}),
	individualConsultationChildFormResponses: paginate({
		mapActionToKey: action => action.childId.toString(),
		types: [
			IndividualConsultationFormResponseTypes.INDIVIDUAL_CONSULTATION_CHILD_FORM_RESPONSES_REQUEST,
			IndividualConsultationFormResponseTypes.INDIVIDUAL_CONSULTATION_CHILD_FORM_RESPONSES_SUCCESS,
			IndividualConsultationFormResponseTypes.INDIVIDUAL_CONSULTATION_CHILD_FORM_RESPONSES_FAILURE
		]
	}),
	selfAssessments: paginate({
		mapActionToKey: action => action.childId ? `child-${action.childId}` : 'all',
		types: [
			selfAssessmentTypes.SELF_ASSESSMENTS_REQUEST,
			selfAssessmentTypes.SELF_ASSESSMENTS_SUCCESS,
			selfAssessmentTypes.SELF_ASSESSMENTS_FAILURE
		]
	}),
	notesByReference: paginate({
		mapActionToKey: action => `${action.referenceType}-${action.reference}`,
		types: [
			NoteActionTypes.NOTES_REQUEST,
			NoteActionTypes.NOTES_SUCCESS,
			NoteActionTypes.NOTES_FAILURE
		]
	}),
	workshops: paginate({
		mapActionToKey: action => 'all',
		types: [
			WorkshopActionTypes.WORKSHOPS_REQUEST,
			WorkshopActionTypes.WORKSHOPS_SUCCESS,
			WorkshopActionTypes.WORKSHOPS_FAILURE
		]
	}),
	sentEmails: paginate({
		mapActionToKey: action => action.listKey || (action.parentId ? `parent-${action.parentId}` : 'all'),
		types: [
			SentEmailsActionTypes.SENT_EMAILS_REPORT_REQUEST,
			SentEmailsActionTypes.SENT_EMAILS_REPORT_SUCCESS,
			SentEmailsActionTypes.SENT_EMAILS_REPORT_FAILURE
		]
	}),
	instalmentPlanTemplates: paginate({
		mapActionToKey: action => 'all',
		types: [
			InstalmentPlanTemplateActionTypes.INSTALMENT_PLAN_TEMPLATES_REQUEST,
			InstalmentPlanTemplateActionTypes.INSTALMENT_PLAN_TEMPLATES_SUCCESS,
			InstalmentPlanTemplateActionTypes.INSTALMENT_PLAN_TEMPLATES_FAILURE
		]
	}),
	payments: paginate({
		mapActionToKey: action => 'all',
		types: [
			PaymentActionTypes.PAYMENTS_REQUEST,
			PaymentActionTypes.PAYMENTS_SUCCESS,
			PaymentActionTypes.PAYMENTS_FAILURE
		]
	}),
	workshopsBySearchTerm: paginate({
		mapActionToKey: action => action.searchTerm,
		appendResults: true,
		types: [
			WorkshopActionTypes.WORKSHOPS_SEARCH_REQUEST,
			WorkshopActionTypes.WORKSHOPS_SEARCH_SUCCESS,
			WorkshopActionTypes.WORKSHOPS_SEARCH_FAILURE
		]
	})
});

// Updates the filtered data for different actions.
const filters = combineReducers({
	moveLessonsChildLessonsByChild: filter({
		mapActionToKey: action => 'all',
		types: [
			MoveLessonActionTypes.MOVE_LESSONS_CHILD_LESSONS_REQUEST,
			MoveLessonActionTypes.MOVE_LESSONS_CHILD_LESSONS_SUCCESS,
			MoveLessonActionTypes.MOVE_LESSONS_CHILD_LESSONS_FAILURE
		]
	}),
	weeklyProgramByCenterAndTerm: filter({
		mapActionToKey: action => `${action.centerId}-${action.termId}`,
		types: [
			LessonAttendanceActionTypes.WEEKLY_PROGRAM_BY_CENTER_AND_TERM_REQUEST,
			LessonAttendanceActionTypes.WEEKLY_PROGRAM_BY_CENTER_AND_TERM_SUCCESS,
			LessonAttendanceActionTypes.WEEKLY_PROGRAM_BY_CENTER_AND_TERM_FAILURE
		]
	}),
	lessonAttendanceWeeklyProgram: filter({
		mapActionToKey: action => 'all',
		types: [
			LessonAttendanceActionTypes.LESSON_ATTENDANCE_WEEKLY_PROGRAMS_REQUEST,
			LessonAttendanceActionTypes.LESSON_ATTENDANCE_WEEKLY_PROGRAMS_SUCCESS,
			LessonAttendanceActionTypes.LESSON_ATTENDANCE_WEEKLY_PROGRAMS_FAILURE
		]
	}),
	kindergartenAttendanceWeeklyProgram: filter({
		mapActionToKey: action => 'all',
		types: [
			KindergartenAttendanceActionTypes.KINDERGARTEN_ATTENDANCE_WEEKLY_PROGRAMS_REQUEST,
			KindergartenAttendanceActionTypes.KINDERGARTEN_ATTENDANCE_WEEKLY_PROGRAMS_SUCCESS,
			KindergartenAttendanceActionTypes.KINDERGARTEN_ATTENDANCE_WEEKLY_PROGRAMS_FAILURE
		]
	}),
	moveLessonsWeeklyProgram: filter({
		mapActionToKey: action => 'all',
		types: [
			MoveLessonActionTypes.MOVE_LESSONS_WEEKLY_PROGRAMS_REQUEST,
			MoveLessonActionTypes.MOVE_LESSONS_WEEKLY_PROGRAMS_SUCCESS,
			MoveLessonActionTypes.MOVE_LESSONS_WEEKLY_PROGRAMS_FAILURE
		]
	}),
	noTeacherUsersByFranchisee: filter({
		mapActionToKey: action => action.franchiseeId.toString(),
		types: [
			TeacherActionTypes.NOTEACHERS_REQUEST,
			TeacherActionTypes.NOTEACHERS_SUCCESS,
			TeacherActionTypes.NOTEACHERS_FAILURE
		]
	}),
	teachersUnpagedByFranchisee: filter({
		mapActionToKey: action => action.franchiseeId.toString(),
		types: [
			TeacherActionTypes.TEACHERS_UNPAGED_REQUEST,
			TeacherActionTypes.TEACHERS_UNPAGED_SUCCESS,
			TeacherActionTypes.TEACHERS_UNPAGED_FAILURE
		]
	}),
	parentsBySearchTerm: filter({
		mapActionToKey: action => action.searchTerm,
		types: [
			ParentActionTypes.PARENTS_REQUEST,
			ParentActionTypes.PARENTS_SUCCESS,
			ParentActionTypes.PARENTS_FAILURE
		]
	}),
	childrenBySearchTerm: filter({
		mapActionToKey: action => action.searchTerm,
		types: [
			ChildActionTypes.CHILDREN_SEARCH_REQUEST,
			ChildActionTypes.CHILDREN_SEARCH_SUCCESS,
			ChildActionTypes.CHILDREN_SEARCH_FAILURE
		]
	}),
	enrolmentsByChild: filter({
		mapActionToKey: action => action.childId.toString(),
		types: [
			EnrolmentActionTypes.ENROLMENTS_BY_CHILD_REQUEST,
			EnrolmentActionTypes.ENROLMENTS_BY_CHILD_SUCCESS,
			EnrolmentActionTypes.ENROLMENTS_BY_CHILD_FAILURE
		]
	}),
	paymentsByChild: filter({
		mapActionToKey: action => action.childId.toString(),
		types: [
			PaymentHistoryActionTypes.PAYMENTS_BY_CHILD_REQUEST,
			PaymentHistoryActionTypes.PAYMENTS_BY_CHILD_SUCCESS,
			PaymentHistoryActionTypes.PAYMENTS_BY_CHILD_FAILURE
		]
	}),
	makeupSummaryByChildAndTerm: filter({
		mapActionToKey: action => `${action.childId}-${action.termId}`,
		types: [
			MakeupSummaryActionTypes.MAKEUP_SUMMARY_BY_CHILD_AND_TERM_REQUEST,
			MakeupSummaryActionTypes.MAKEUP_SUMMARY_BY_CHILD_AND_TERM_SUCCESS,
			MakeupSummaryActionTypes.MAKEUP_SUMMARY_BY_CHILD_AND_TERM_FAILURE
		]
	}),
	workshopSessionsByWorkshop: filter({
		mapActionToKey: action => action.workshopId.toString(),
		types: [
			WorkshopActionTypes.WORKSHOP_SESSIONS_REQUEST,
			WorkshopActionTypes.WORKSHOP_SESSIONS_SUCCESS,
			WorkshopActionTypes.WORKSHOP_SESSIONS_FAILURE
		]
	}),
	savedQueriesByType: filter({
		mapActionToKey: action => action.queryType,
		types: [
			SavedQueryActionTypes.SAVED_QUERIES_REQUEST,
			SavedQueryActionTypes.SAVED_QUERIES_SUCCESS,
			SavedQueryActionTypes.SAVED_QUERIES_FAILURE
		]
	})
});

const exports = combineReducers({
	paymentHistories: exportToFile({
		mapActionToKey: action => 'all',
		types: [
			PaymentHistoryActionTypes.PAYMENT_EXPORT_REQUEST,
			PaymentHistoryActionTypes.PAYMENT_EXPORT_SUCCESS,
			PaymentHistoryActionTypes.PAYMENT_EXPORT_FAILURE
		]
	}),
	instalmentPayments: exportToFile({
		mapActionToKey: action => 'all',
		types: [
			InstalmentPaymentsActionTypes.INSTALMENT_PAYMENTS_EXPORT_REQUEST,
			InstalmentPaymentsActionTypes.INSTALMENT_PAYMENTS_EXPORT_SUCCESS,
			InstalmentPaymentsActionTypes.INSTALMENT_PAYMENTS_EXPORT_FAILURE
		]
	}),
	payments: exportToFile({
		mapActionToKey: action => 'all',
		types: [
			PaymentActionTypes.PAYMENTS_EXPORT_REQUEST,
			PaymentActionTypes.PAYMENTS_EXPORT_SUCCESS,
			PaymentActionTypes.PAYMENTS_EXPORT_FAILURE
		]
	}),
	workshopPayments: exportToFile({
		mapActionToKey: action => 'all',
		types: [
			WorkshopPaymentsActionTypes.WORKSHOP_PAYMENTS_EXPORT_REQUEST,
			WorkshopPaymentsActionTypes.WORKSHOP_PAYMENTS_EXPORT_SUCCESS,
			WorkshopPaymentsActionTypes.WORKSHOP_PAYMENTS_EXPORT_FAILURE
		]
	}),
	campaignStats: exportToFile({
		mapActionToKey: action => 'all',
		types: [
			CampaignStatsActionTypes.CAMPAIGN_STATS_EXPORT_REQUEST,
			CampaignStatsActionTypes.CAMPAIGN_STATS_EXPORT_SUCCESS,
			CampaignStatsActionTypes.CAMPAIGN_STATS_EXPORT_FAILURE
		]
	}),
	individualConsultations: exportToFile({
		mapActionToKey: action => 'all',
		types: [
			IndividualConsultationActionTypes.INDIVIDUAL_CONSULTATIONS_EXPORT_REQUEST,
			IndividualConsultationActionTypes.INDIVIDUAL_CONSULTATIONS_EXPORT_SUCCESS,
			IndividualConsultationActionTypes.INDIVIDUAL_CONSULTATIONS_EXPORT_FAILURE
		]
	}),
	waitingList: exportToFile({
		mapActionToKey: action => 'all',
		types: [
			WaitingListActionTypes.WAITING_LIST_EXPORT_REQUEST,
			WaitingListActionTypes.WAITING_LIST_EXPORT_SUCCESS,
			WaitingListActionTypes.WAITING_LIST_EXPORT_FAILURE
		]
	}),
	monthlyPayments: exportToFile({
		mapActionToKey: action => 'all',
		types: [
			MonthlyPaymentReportActionTypes.MONTHLY_PAYMENT_EXPORT_REQUEST,
			MonthlyPaymentReportActionTypes.MONTHLY_PAYMENT_EXPORT_SUCCESS,
			MonthlyPaymentReportActionTypes.MONTHLY_PAYMENT_EXPORT_FAILURE
		]
	}),
	cancellationCreditNotes: exportToFile({
		mapActionToKey: action => 'all',
		types: [
			CancellationCreditNotesReportActionTypes.CANCELLATION_CREDIT_NOTES_EXPORT_REQUEST,
			CancellationCreditNotesReportActionTypes.CANCELLATION_CREDIT_NOTES_EXPORT_SUCCESS,
			CancellationCreditNotesReportActionTypes.CANCELLATION_CREDIT_NOTES_EXPORT_FAILURE
		]
	}),
	enrolments: exportToFile({
		mapActionToKey: action => 'all',
		types: [
			EnrolmentActionTypes.ENROLMENTS_EXPORT_REQUEST,
			EnrolmentActionTypes.ENROLMENTS_EXPORT_SUCCESS,
			EnrolmentActionTypes.ENROLMENTS_EXPORT_FAILURE
		]
	}),
	badges: exportToFile({
		mapActionToKey: action => 'all',
		types: [
			EnrolmentActionTypes.CHILD_BADGES_EXPORT_REQUEST,
			EnrolmentActionTypes.CHILD_BADGES_EXPORT_SUCCESS,
			EnrolmentActionTypes.CHILD_BADGES_EXPORT_FAILURE
		]
	}),
	centralisedRoyalty: exportToFile({
		mapActionToKey: action => 'all',
		types: [
			CentralisedRoyaltyReportActionTypes.CENTRALISED_ROYALTY_EXPORT_REQUEST,
			CentralisedRoyaltyReportActionTypes.CENTRALISED_ROYALTY_EXPORT_SUCCESS,
			CentralisedRoyaltyReportActionTypes.CENTRALISED_ROYALTY_EXPORT_FAILURE
		]
	}),
	kindergartenReport: exportToFile({
		mapActionToKey: action => 'all',
		types: [
			KindergartenMonthlyReportActionTypes.KINDERGARTEN_REPORT_EXPORT_REQUEST,
			KindergartenMonthlyReportActionTypes.KINDERGARTEN_REPORT_EXPORT_SUCCESS,
			KindergartenMonthlyReportActionTypes.KINDERGARTEN_REPORT_EXPORT_FAILURE
		]
	}),
	loyalChildren: exportToFile({
		mapActionToKey: action => 'all',
		types: [
			LoyalChildrenReportActionTypes.LOYAL_CHILDREN_EXPORT_REQUEST,
			LoyalChildrenReportActionTypes.LOYAL_CHILDREN_EXPORT_SUCCESS,
			LoyalChildrenReportActionTypes.LOYAL_CHILDREN_EXPORT_FAILURE
		]
	}),
	prepaidTerms: exportToFile({
		mapActionToKey: action => 'all',
		types: [
			PrepaidTermsReportActionTypes.PREPAID_TERMS_EXPORT_REQUEST,
			PrepaidTermsReportActionTypes.PREPAID_TERMS_EXPORT_SUCCESS,
			PrepaidTermsReportActionTypes.PREPAID_TERMS_EXPORT_FAILURE
		]
	}),
	upcomingCancellations: exportToFile({
		mapActionToKey: action => 'all',
		types: [
			UpcomingCancellationsActionTypes.UPCOMING_CANCELLATIONS_EXPORT_REQUEST,
			UpcomingCancellationsActionTypes.UPCOMING_CANCELLATIONS_EXPORT_SUCCESS,
			UpcomingCancellationsActionTypes.UPCOMING_CANCELLATIONS_EXPORT_FAILURE
		]
	}),
	softwareFeeReport: exportToFile({
		mapActionToKey: action => 'all',
		types: [
			SoftwareFeeReportActionTypes.SOFTWARE_FEE_REPORT_EXPORT_REQUEST,
			SoftwareFeeReportActionTypes.SOFTWARE_FEE_REPORT_EXPORT_SUCCESS,
			SoftwareFeeReportActionTypes.SOFTWARE_FEE_REPORT_EXPORT_FAILURE
		]
	}),
	reportChildrenDetails: exportToFile({
		mapActionToKey: action => 'all',
		types: [
			ReportChildrenActionTypes.REPORT_CHILDREN_EXPORT_REQUEST,
			ReportChildrenActionTypes.REPORT_CHILDREN_EXPORT_SUCCESS,
			ReportChildrenActionTypes.REPORT_CHILDREN_EXPORT_FAILURE
		]
	}),
	sessionManagement: exportToFile({
		mapActionToKey: action => 'all',
		types: [
			SessionManagementActionTypes.SESSION_MANAGEMENT_EXPORT_REQUEST,
			SessionManagementActionTypes.SESSION_MANAGEMENT_EXPORT_SUCCESS,
			SessionManagementActionTypes.SESSION_MANAGEMENT_EXPORT_FAILURE
		]
	}),
	royaltyReport: exportToFile({
		mapActionToKey: action => 'all',
		types: [
			RoyaltyReportActionTypes.ROYALTY_REPORT_EXPORT_REQUEST,
			RoyaltyReportActionTypes.ROYALTY_REPORT_EXPORT_SUCCESS,
			RoyaltyReportActionTypes.ROYALTY_REPORT_EXPORT_FAILURE
		]
	}),
	royaltyReportPayments: exportToFile({
		mapActionToKey: action => 'all',
		types: [
			RoyaltyReportActionTypes.ROYALTY_REPORT_PAYMENTS_EXPORT_REQUEST,
			RoyaltyReportActionTypes.ROYALTY_REPORT_PAYMENTS_EXPORT_SUCCESS,
			RoyaltyReportActionTypes.ROYALTY_REPORT_PAYMENTS_EXPORT_FAILURE
		]
	})
})

// Static catalog of email placeholder tags for the message-template editor
const messageTemplateTags = (state = { groups: [], templateGroups: {}, defaultGroups: [] }, action) => {
	switch (action.type) {
		case MessageTemplateActionTypes.MESSAGE_TEMPLATE_TAGS_SUCCESS:
			return action.response || state;
		default:
			return state;
	}
};

// enableReinitialize dispatches INITIALIZE without the keepSubmitSucceeded option, and INITIALIZE
// drops submitSucceeded. Every save that actually changes the stored entity therefore reinitialises
// the form and hides the success message a moment after it appears. Carry the flag over instead.
const form = (state = {}, action) => {
	const nextState = formReducer(state, action);

	if (action.type !== formActionTypes.INITIALIZE) {
		return nextState;
	}

	const formName = action.meta && action.meta.form;
	const succeededBefore = formName && state[formName] && state[formName].submitSucceeded;
	if (!succeededBefore || !nextState[formName] || nextState[formName].submitSucceeded) {
		return nextState;
	}

	return {
		...nextState,
		[formName]: { ...nextState[formName], submitSucceeded: true }
	};
};

const rootReducer = combineReducers({
	lookups,
	entities,
	pagination,
	form,
	auth,
	profile,
	analytics,
	formsAnalytics,
	configuration: combineReducers({ franchisor, lookups, language, releaseNotes }),
	junction,
	filters,
	exports,
	messageTemplateTags
});

export default rootReducer;